import "../modulo404/error404.css"

export default function Error404() {
  return (
    <div className="error404-container">
      <div className="error404-box">
        <h1 className="error404-code">404</h1>
        <h2 className="error404-title">Página no encontrada</h2>
        <p className="error404-text">
          La página que buscas no existe o fue movida.
        </p>

          Volver al inicio
      </div>
    </div>
  );
}